// extracted by mini-css-extract-plugin
export default {"card":"AdvantageCard_card__o6geB"};